const GtmEvents = {
  BUTTON_CLICK: 'button_click',
  LINK_CLICK: 'link_click',
  CHECKBOX_CLICK: 'checkbox_click',
  RADIOBUTTON_CLICK: 'radiobutton_click',
  DROPDOWN_SELECTED: 'dropdown_selected',
  TEXTFIELD_INPUT: 'textfield_input',
  VALIDATION_ERROR: 'validation_error',
  SEARCH_CONDUCTED: 'search_conducted',
  TOGGLE_CLICK: 'toggle_click',
  TURNSTILE_SUCCESS: 'turnstile_success',
  TURNSTILE_ERROR: 'turnstile_error',
  LABEL_ACCESS: 'label_access',
} as const;

export default GtmEvents;
